import { b as base } from "../../../../chunks/server.js";
import "../../../../chunks/url.js";
import "@sveltejs/kit/internal/server";
import "../../../../chunks/root.js";
import { g as getOAuthConfig, O as OAUTH_CIMD_CLIENT_ID, a as getCallbackUrl } from "../../../../chunks/oauth.js";
const GET = async ({ url }) => {
  const config = await getOAuthConfig();
  if (!config) {
    return new Response("OAuth is not configured", { status: 404 });
  }
  if (config.clientId !== OAUTH_CIMD_CLIENT_ID) {
    return new Response("CIMD is disabled", { status: 404 });
  }
  return new Response(
    JSON.stringify({
      client_id: new URL(url.pathname, url.origin).toString(),
      client_name: "Mongoku",
      client_uri: `${url.origin}${base}`,
      redirect_uris: [getCallbackUrl(url.origin)],
      token_endpoint_auth_method: "none",
      scope: config.scopes
    }),
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};
export {
  GET
};
